
import { Component, Vue } from "vue-property-decorator";
import { delDictType, getDictTypeListPage } from "@/api/api-basic";
import { objAny } from "@/common/common-interface";
import addDictionary from "./components/add-dictionary.vue";
import dictionaryChild from "./dictionary-child.vue";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-add-dictionary": addDictionary,
    "pi-dictionary-child": dictionaryChild
  }
})
export default class SystemConfigLog extends Vue {
  private privilege: objAny = {};
  private typeFlagList: objAny = {
    "0": i18n.t("dictionary.read"),
    "1": i18n.t("dictionary.edit"),
    "2": i18n.t("dictionary.addOp")
  };
  private formInline: objAny = {
    globalOrder: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    globalSearch: ""
  };
  private total = 0;
  private loading = false;
  private childTab = false;
  private typePkId = "";
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: i18n.t("dictionary.typeName"),
      key: "typeName",
      minWidth: 100,
      align: "center"
    },
    {
      title: i18n.t("dictionary.typePkId"),
      key: "typePkId",
      width: 80,
      align: "center"
    },
    {
      title: i18n.t("dictionary.itemList"),
      key: "itemList",
      minWidth: 180,
      slot: "itemList",
      align: "center"
    },
    {
      title: i18n.t("dictionary.typeFlag"),
      key: "typeFlag",
      minWidth: 90,
      align: "center",
      slot: "typeFlag"
    },
    {
      title: i18n.t("dictionary.remark"),
      key: "remark",
      minWidth: 140,
      align: "center"
    },
    {
      title: i18n.t("dictionary.modifyTime"),
      key: "modifyTime",
      width: 160,
      slot: "modifyTime",
      align: "center",
      render: (h: Function, params: objAny) => {
        if (params.row.modifyTime) {
          return h(
            "div",
            this.$common.userDate(
              new Date(params.row.modifyTime),
              "yyyy-MM-dd HH:MM:SS"
            )
          );
        } else {
          return h("div", "");
        }
      }
    },
    {
      title: i18n.t("operation"),
      key: "resultDes",
      width: 110,
      slot: "action",
      align: "center"
    }
  ];
  private addDictionary: objAny = {};
  private dictionaryChild: objAny = {};

  public queryClick(): void {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }
  public openAddDictionary() {
    this.addDictionary.open();
  }
  public addItem(item: objAny) {
    this.childTab = true;
    this.typePkId = item.typePkId;
    this.dictionaryChild.initData(item);
    // this.selectItem= item;
    // this.addDictionary.open(item);
  }
  public isShow() {
    this.childTab = false;
  }
  public updataItem(item: objAny) {
    this.addDictionary.open(item);
  }
  public delItem(item: objAny): void {
    this.alldDelitem(item.typePkId);
  }
  async alldDelitem(id: string): Promise<void> {
    const ret = await delDictType({ pkid: id });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("deleteSuccess"));
      this.getTableList();
    }
  }

  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getDictTypeListPage(this.formInline);

    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
  }

  mounted() {
    this.$nextTick(() => {
      this.addDictionary = this.$refs["addDictionary"];
      this.dictionaryChild = this.$refs["dictionaryChild"];
    });

    this.privilege = this.$route.meta.privilegeVoObj;
    this.getTableList();
  }
}
